import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const paymentService = createApi({
  reducerPath: "payment",
  baseQuery: fetchBaseQuery({
    baseUrl: "/api/",
    prepareHeaders: (headers, { getState }) => {
      const token = getState()?.authReducer?.userToken;

      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }

      headers.set("accept", "application/json");

      return headers;
    },
  }),
  endpoints: (builder) => ({
    requestPayment: builder.mutation({
      query: (orderId) => ({
        url: `payment/request/${orderId}`,
        method: "POST",
      }),
    }),

    reconcilePayment: builder.mutation({
      query: (orderId) => ({
        url: `payment/reconcile/${orderId}`,
        method: "POST",
      }),
    }),

    paymentSettings: builder.query({
      query: () => ({
        url: "payment/settings",
        method: "GET",
      }),
    }),

    checkSnappEligible: builder.query({
      query: (amount) => ({
        url: `payment/snapp/eligible?amount=${amount}`,
        method: "GET",
      }),
    }),

    requestSnappPayment: builder.mutation({
      query: (orderId) => ({
        url: `payment/snapp/request/${orderId}`,
        method: "POST",
      }),
    }),

    abandonPaymentRecovery: builder.mutation({
      query: (orderId) => ({
        url: `payment/recovery/${orderId}/abandon`,
        method: "POST",
      }),
    }),

    verifyPayment: builder.query({
      query: (id) => ({
        url: `payment/verify?order_ref=${id}`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useRequestPaymentMutation,
  useReconcilePaymentMutation,
  usePaymentSettingsQuery,
  useCheckSnappEligibleQuery,
  useRequestSnappPaymentMutation,
  useAbandonPaymentRecoveryMutation,
  useVerifyPaymentQuery,
} = paymentService;

export default paymentService;
